import vars from '../helpers';

const $intro = $('.intro__persons');

if (vars.isMobile()) {
	vars.$window.on('scroll', () => {
		if (vars.$window.scrollTop() > $intro.offset().top + $intro.outerHeight()) {
			vars.$html.addClass('is-header-fixed');
		} else {
			vars.$html.removeClass('is-header-fixed');
		}
	});
}
